import Popover from '../ui/Popover';

const EMOJI_LIST = [
  '👍', '👎', '❤️', '😂', '🎉', '🔥', '👀', '💯',
  '🙌', '😢', '🤔', '✅', '🚀', '💪', '👏', '🫡',
  '😍', '🤣', '😮', '💀', '🙏', '❌', '⭐', '🦉',
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
  visible: boolean;
  anchorEl: HTMLElement | null;
}

export default function EmojiPicker({ onSelect, onClose, visible, anchorEl }: EmojiPickerProps) {
  return (
    <Popover
      open={visible}
      anchorEl={anchorEl}
      onClose={onClose}
      style={{ padding: '8px' }}
    >
      <div className="grid grid-cols-8 gap-0.5" style={{ width: '240px' }}>
        {EMOJI_LIST.map(emoji => (
          <button
            key={emoji}
            onClick={(e) => {
              e.stopPropagation();
              onSelect(emoji);
              onClose();
            }}
            className="hover-wash pressable flex items-center justify-center"
            style={{
              width: '28px',
              height: '28px',
              border: 'none',
              background: 'transparent',
              borderRadius: 'var(--radius-xs)',
              fontSize: '16px',
              cursor: 'pointer',
            }}
            title={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
    </Popover>
  );
}
